import script from "./Cell.vue?vue&type=script&lang=js"
export * from "./Cell.vue?vue&type=script&lang=js"

import "./Cell.vue?vue&type=style&index=0&id=622c7932&scoped=true&lang=scss"
script.__scopeId = "data-v-622c7932"

export default script